var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M33.733 13.698c0-.255-.056-.513-.205-.613s-.424-.16-.825.104c-3.861 2.544-7.465 8.394-6.436 15.515-1.287-.763-2.233-1.903-3.005-3.175-.258-.508-.707-1.154-1.134-1.539-.288-.26-.6-.374-1.01.136C18.803 26.924 17 30.23 17 33.791 17 40.913 22.406 46 29.871 46S43 40.659 43 33.791c0-3.795-2.015-6.263-3.957-8.642l-.42-.514-.362-.437c-2.215-2.659-4.528-5.437-4.528-10.5m-8.495 23.146c0 2.034 1.802 3.815 4.118 3.815 3.347 0 6.179-2.798 6.436-5.85 0-1.526-.257-3.307-.772-4.833-1.287 1.526-3.862 2.544-6.178 3.052-2.317.509-3.604 1.78-3.604 3.816",
    clipRule: "evenodd"
  })));
};
export default SvgLogo;